module.exports = __webpack_public_path__ + "media/custom/images/logo-6ba14934d23fa23d5034d84368aa1574.png";